import { useQuery } from '@tanstack/react-query';

import { myRecommendedOutreachMembersKey, requestMyRecommendedOutreachMembers } from './membersApi';

/**
 * The rows of the directory's Recommended Outreach view, at the app's default staleness.
 *
 * No `Failure` variant to handle: `myRecommendedOutreachMembers` is a pure read, so infrastructure
 * errors travel the standard GraphQL errors envelope, and the directory shows them as its error state.
 */
export function useMyRecommendedOutreachMembers() {
  return useQuery({ queryKey: myRecommendedOutreachMembersKey, queryFn: requestMyRecommendedOutreachMembers });
}
